import React from 'react';
import SignTable from 'components/SignTable';
import SignCard from 'components/SignCard';
import CompatibilityCard from 'components/CompatibilityCard';
import MockUpSignUpForm from 'components/MockUpSignUpForm';
import {
  HeaderContainer,
  HeroSubTitle,
  CardContainer,
  HeroHeader,
  HeroBody,
} from './Home.styles';

const Home = () => {
  return (
    <>
      {/* <AdWrapper>
        <DFPAdSenseUnit banner adUnit="starguide_home_top_banner" className="center" />
      </AdWrapper> */}
      <HeaderContainer>
        <HeroHeader>Daily Horoscopes</HeroHeader>
        <HeroBody>
          Don&apos;t be caught by surprise.
          View your horoscope to help you plan your day - every day!
          Select your sign to get started.
        </HeroBody>
        <HeroSubTitle>Choose your sign to get started</HeroSubTitle>
      </HeaderContainer>
      <SignTable fullwidth />
      <CardContainer>
        <SignCard />
        <CompatibilityCard />
      </CardContainer>
      {/* <AdWrapper>
        <DFPAdSenseUnit rect adUnit="starguide_home_mid_page" className="center" />
      </AdWrapper> */}
      <MockUpSignUpForm />
      {/* <AdWrapper>
        <DFPAdSenseUnit rect adUnit="starguide_home_bottom" className="center" />
      </AdWrapper> */}
    </>
  );
};

export default Home;
